<template>
  <div class="wrap">
    <!-- Map -->
    <div id="map">
      <div class="address-text">
        <p class="center-text">
          <v-text-field
            name="name"
            label="Tìm kiếm địa chỉ"
            id="id"
            solo
            clearable
            v-model="address"
            v-show="isAddGeofence || isEditGeofence"
            @change="searchAddress()"
            :loading="isLoading"
          ></v-text-field>
        </p>
      </div>
    </div>
    <!-- Change map type -->
    <div class="map-type" @click="changeMapType()">
      <img :src="`/static/icons/map/${getMaptypeName()}.png`" alt="MapType" />
    </div>
    <!-- Get location -->
    <div class="get-location">
      <!-- <img :src="`/static/icons/map/${getMaptypeName()}.png`" alt="MapType"> -->
      <v-btn fab small @click="getMyLocation()">
        <v-icon>my_location</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import * as MapUtil from '@/utils/maputil';
import * as DateTimeUtil from '@/utils/datetime';
import { mapActions, mapGetters, mapMutations } from 'vuex';
//  mapType: 'vietmap' or 'google-map', 
export default {
  name: 'vietmap',
  data () {
    return {
      // Map
      mapType: 'vietmap',
      mapLayer: null,
      map: null,
      address: '',
      isLoading: false,
      geofenceMarkers: [],
      geofenceToAdd: {},
      // My location
      myLocation: {
        marker: null,
        circle: null
      }
    };
  },
  computed: {
    ...mapGetters([
      'geofences',
      'selectedGeofence',
      'isAddGeofence',
      'isEditGeofence',
      'addGeofenceRadius'
    ])
  },
  watch: {
    isAddGeofence () {
      if (this.isAddGeofence) {
        this.addFenceToMap();
      } else {
        this.address = '';
        if (this.geofenceToAdd.marker && this.geofenceToAdd.circle) {
          this.map.removeLayer(this.geofenceToAdd.marker);
          this.map.removeLayer(this.geofenceToAdd.circle);
        }
      }
    },

    isEditGeofence () {
      if (this.isEditGeofence) {
        // add fence to map
        let fence = this.geofenceMarkers.filter(
          a => a.id === this.selectedGeofence.id
        )[0];
        console.log(fence);
        let latlng = fence.marker.getLatLng();
        console.log(latlng);
        this.addFenceToMap(latlng);

        // remove old fence
        this.map.removeLayer(fence.marker);
        this.map.removeLayer(fence.circle);
      } else {
        if (this.geofenceToAdd.marker && this.geofenceToAdd.circle) {
          this.map.removeLayer(this.geofenceToAdd.marker);
          this.map.removeLayer(this.geofenceToAdd.circle);
        }
        this.drawGeofences();
      }
    },

    addGeofenceRadius () {
      this.changeRadius();
    },

    selectedGeofence () {
      this.jumpToSelectedGeofence();
    },

    geofences () {
      this.drawGeofences();
    }
  },

  mounted () {
    // eslint-disable-next-line
    this.map = L.map("map", {
      attributionControl: false,
      zoomControl: false
    }).setView(MapUtil.MAP_CONFIG.center, MapUtil.MAP_CONFIG.zoom);
    this.mapLayer = MapUtil.createMapTileLayer(this.mapType);
    this.mapLayer.addTo(this.map);
    // this.googleGeocoding('03 tran nhan ton');
  },

  methods: {
    ...mapActions(['googleGeocoding']),
    ...mapMutations(['SET_ADD_GEOFENCE_LATLNG', 'SET_SELECTED_GEOFENCE']),

    getMaptypeName () {
      if (this.mapType === 'roadmap') {
        return 'hybrid';
      }
      return 'roadmap';
    },

    changeMapType () {
      if (this.mapType === 'roadmap') {
        this.mapType = 'hybrid';
      } else if (this.mapType === 'hybrid') {
        this.mapType = 'roadmap';
      }
      this.map.removeLayer(this.mapLayer);
      this.mapLayer = MapUtil.createMapTileLayer(this.mapType);
      this.mapLayer.addTo(this.map);
    },

    removeAllFenceFromMap () {
      this.geofenceMarkers.map(item => {
        this.map.removeLayer(item.marker);
        this.map.removeLayer(item.circle);
        return 0;
      });
    },

    drawGeofences () {
      this.removeAllFenceFromMap();
      this.geofenceMarkers = [];

      this.geofences.map(item => {
        let latlng = MapUtil.getLatLngFromXY(item.centerX, item.centerY);

        // eslint-disable-next-line
        let marker = L.marker(latlng, {
          icon: MapUtil.DEFAULT_MARKER
        })
          .bindTooltip(`${item.name} (${item.radius}m)`, {
            permanent: true,
            direction: 'bottom',
            opacity: 1,
            offset: [0, 5]
          })
          .addTo(this.map);
  
        marker.on('click', e => {
          this.SET_SELECTED_GEOFENCE(item);
        });

        // eslint-disable-next-line
        let circle = L.circle(latlng, item.radius, MapUtil.FENCE_OPTION).addTo(
          this.map
        );

        let fence = {
          id: item.id,
          marker: marker,
          circle: circle
        };

        this.geofenceMarkers.push(fence);
        return 0;
      });
    },

    jumpToSelectedGeofence () {
      let fence = this.geofenceMarkers.filter(
        a => a.id === this.selectedGeofence.id
      )[0];
      this.map.setView(fence.marker.getLatLng());
    },

    addFenceToMap (editLatlng) {
      let latlng = editLatlng || this.map.getCenter();
      this.SET_ADD_GEOFENCE_LATLNG(latlng);
      // eslint-disable-next-line
      let marker = L.marker(latlng, {
        icon: MapUtil.DEFAULT_MARKER,
        draggable: true
      })
        .bindTooltip(`${this.addGeofenceRadius}m`, {
          permanent: true,
          direction: 'bottom',
          opacity: 1,
          offset: [0, 5]
        })
        .addTo(this.map)
        .bindPopup('Bạn có thể di chuyển vùng giới hạn đến vị trí mong muốn', {
          // eslint-disable-next-line
          offset: new L.Point(0, -40)
        })
        .openPopup();
      // eslint-disable-next-line
      let circle = L.circle(
        latlng,
        this.addGeofenceRadius,
        MapUtil.FENCE_OPTION
      ).addTo(this.map);

      this.geofenceToAdd.marker = marker;
      this.geofenceToAdd.circle = circle;
      this.map.setView(latlng);

      this.geofenceToAdd.marker.on('drag', e => {
        this.map.removeLayer(this.geofenceToAdd.circle);
        let newLatLng = this.geofenceToAdd.marker.getLatLng();
        this.SET_ADD_GEOFENCE_LATLNG(newLatLng);
        // eslint-disable-next-line
        this.geofenceToAdd.circle = L.circle(
          newLatLng,
          this.addGeofenceRadius,
          MapUtil.FENCE_OPTION
        ).addTo(this.map);
      });
    },

    changeRadius () {
      if (this.geofenceToAdd.circle && this.geofenceToAdd.marker) {
        this.geofenceToAdd.circle.setRadius(this.addGeofenceRadius);
        this.geofenceToAdd.marker.setTooltipContent(
          `${this.addGeofenceRadius}m`
        );
      }
    },

    searchAddress () {
      if (this.address) {
        this.isLoading = true;
        this.googleGeocoding(this.address)
          .then(latlng => {
            this.isLoading = false;

            this.geofenceToAdd.marker.setLatLng(latlng);
            this.SET_ADD_GEOFENCE_LATLNG(latlng);
            this.map.setView(latlng);

            this.map.removeLayer(this.geofenceToAdd.circle);
            // eslint-disable-next-line
            this.geofenceToAdd.circle = L.circle(
              latlng,
              this.addGeofenceRadius,
              MapUtil.FENCE_OPTION
            ).addTo(this.map);
          })
          .catch(_ => {
            this.isLoading = false;
            window.getApp.showMessage(
              'Không tìm thấy địa chỉ, vui lòng nhập chính xác hơn',
              'error'
            );
          });
      }
    },

    getMyLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          if (this.myLocation.marker && this.myLocation.circle) {
            this.map.removeLayer(this.myLocation.marker);
            this.map.removeLayer(this.myLocation.circle);
          }

          let latlng = [position.coords.latitude, position.coords.longitude];
          this.map.setView(latlng, 16);

          // eslint-disable-next-line
          let marker = L.marker(latlng, { icon: MapUtil.MY_LOCATION_MARKER }).addTo(this.map);
          // eslint-disable-next-line
          let circle = L.circle(latlng, 100, MapUtil.MY_LOCATION_FENCE_OPTION).addTo(this.map);

          this.myLocation.marker = marker;
          this.myLocation.circle = circle;
        });
      }
    }
  }
};
</script>

<style scoped>
#map {
  height: 100%;
  width: 100%;
  z-index: 3;
}
.wrap {
  height: 100%;
  width: 100%;
}
.player {
  bottom: 0 !important;
  position: absolute;
  z-index: 4;
}
.btn-change {
  margin-top: 3px;
  margin-left: -2px;
}
.md {
  width: calc(100% - 400px);
}
.lg {
  width: 640px;
  margin-left: calc((100% - 400px - 640px) / 2);
}
.historySlider {
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 8px !important;
}
.date {
  margin-right: 12px;
}
.map-type {
  position: absolute;
  bottom: -2px;
  left: 4px;
  z-index: 3;
  cursor: pointer;
}
.get-location {
  position: absolute;
  bottom: 15px;
  right: 400px;
  z-index: 3;
  cursor: pointer;
}
</style>
<style>
.small-button {
  margin: 4px;
}
.address-text {
  top: 12px !important;
  position: absolute;
  z-index: 600;
  width: 60%;
  margin-left: 20%;
}
.center-text {
  text-align: center;
}
.get-location >>> .v-btn .v-icon {
  height: initial;
}
</style>



// WEBPACK FOOTER //
// src/pages/map/components/geofencemap.vue